// removed by extract-text-webpack-plugin
module.exports = {"toggle":"_3kXWg","selected":"_2Pn54"};


//////////////////
// WEBPACK FOOTER
// ./components/Toggle.css
// module id = 478
// module chunks = 3 4 5